import React, { useEffect, useState } from 'react';
import { Button, Table, Typography, Space, Popconfirm, Tag } from 'antd';
import { PlusOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AxiosCaller from '../../../../authenticatie/AxiosCaller';
import { Trash2, Pencil } from 'lucide-react';
import { openNotificationSuccess, openNotificationError } from '../../../../Components/Notification/Notification';


const { Title } = Typography;

const KlassenOverzichtScreen = () => {
  const { get, del } = AxiosCaller();
  const [klasses, setKlasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchKlasses();
  }, []);

  const fetchKlasses = async () => {
    try {
      const response = await get('/klas');
      const sortedKlasses = response.data.sort((a, b) => a.naam.localeCompare(b.naam));
      setKlasses(sortedKlasses);
    } catch (error) {
      console.error(error)
      openNotificationError("Fout bij ophalen van klassen", error)
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (record) => {
    try {
      await del(`/klas/${record._id}`);
      openNotificationSuccess("Klas succesvol verwijderd")
      await fetchKlasses()

    } catch (error) {
      console.error(error)
      openNotificationError("Fout bij verwijderen van klas", error)
    }
  };

  const handleEdit = (record) => {
    navigate('/Admin/configuratie/MakenAanpassenKlas', { state: record });
  };

  // Filter options for 'klastype'
  const klasTypes = Array.from(new Set(klasses.map((klas) => klas.klasType?.naam || 'Unknown'))); // Assuming `klasType` is an object with `naam`

  const columns = [
    {
      title: 'Klas',
      dataIndex: 'naam',
      sorter: (a, b) => a.naam.localeCompare(b.naam),
      render: (naam) => naam,
    },
    {
      title: 'Aantal',
      dataIndex: 'aantal',
      render: (aantal) => (
        <Space>
          <UserOutlined /> {aantal}
        </Space>
      ),
    },
    {
      title: 'Klastype',
      dataIndex: ['klasType', 'naam'],
      filters: klasTypes.map((type) => ({
        text: type,
        value: type,
      })),
      onFilter: (value, record) => record.klasType?.naam === value, // Compare klasType name to the filter value
      sorter: (a, b) => a.klasType?.naam.localeCompare(b.klasType?.naam),
    },
    {
      title: 'Lokaal',
      dataIndex: 'lokaal',
    },
    {
      title: 'Allergenen',
      dataIndex: 'allergenen',
      render: (allergenen) => (
        <div>
          {allergenen.map((allergen) => (
            <Tag key={allergen._id} color="green">
              {allergen.allergeen.naam}: {allergen.aantal}
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: 'Acties',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<Pencil style={{ color: 'var(--primary-color)', fontSize: '18px' }} />}
            onClick={() => handleEdit(record)}
            style={{ fontSize: '18px' }}
          />
          <Popconfirm
            title={`Weet je zeker dat je '${record.naam}' wilt verwijderen?`}
            onConfirm={() => handleRemove(record)}
            okText="Ja"
            cancelText="Nee"
          >
            <Trash2 className="delete-button" style={{ fontSize: '18px', color: 'var(--primary-color)' }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="Screen-container">
      <div className="space-between">
      <h1 className='title'>Klassen</h1>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate('/Admin/configuratie/MakenAanpassenKlas')}
          className="button"
        >
          Nieuwe klas
        </Button>
      </div>

      <Table
        dataSource={klasses.map((klas) => ({ ...klas, key: klas._id }))}
        columns={columns}
        loading={loading}
        pagination={false}
        rowClassName={(record, index) => (index % 2 === 0 ? 'custom-table-row-even' : 'custom-table-row-odd')}
        bordered
        scroll={{ y: 0.7 * window.innerHeight }}
      />
    </div>
  );
};

export default KlassenOverzichtScreen;
